import { SourceTypes } from './components/datasource-form';

export const REPORT_SOURCE_TYPES = [SourceTypes.Jdbc];
